import { useRef, useEffect, useCallback } from "react";

const CustomBottomScrollListener = ({ offset = 50, onBottom, children }) => {
  const containerRef = useRef();
  const lastTriggeredHeight = useRef(null);

  const checkBottom = useCallback(() => {
    const el = containerRef.current;
    if (!el) return;

    const { scrollTop, scrollHeight, clientHeight } = el;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

    if (distanceFromBottom <= offset) {
      if (lastTriggeredHeight.current !== scrollHeight) {
        lastTriggeredHeight.current = scrollHeight;
        if (typeof onBottom === "function") {
          onBottom();
        }
      }
    } else {
      lastTriggeredHeight.current = null;
    }
  }, [offset, onBottom]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.addEventListener("scroll", checkBottom, { passive: true });
    const resizeObserver = new ResizeObserver(() => {
      checkBottom();
    });
    resizeObserver.observe(container);
    if (container.firstElementChild) {
      resizeObserver.observe(container.firstElementChild);
    }
    checkBottom();
    return () => {
      container.removeEventListener("scroll", checkBottom);
      resizeObserver.disconnect();
    };
  }, [checkBottom]);

  return children(containerRef);
};

export default CustomBottomScrollListener;
